import { OnSiteManagerState } from './types';
import { combineReducers } from 'redux';
import { onSiteVisitsReducer } from './on-site-visits/reducer';
import { onSitesReducer } from './on-sites/reducer';
import { partnerReducer } from './partners/reducer';

export const onSiteManagerReducer = combineReducers<OnSiteManagerState>({
  partners: partnerReducer,
  onSites: onSitesReducer,
  onSiteVisits: onSiteVisitsReducer,
});
